<template>
    <div
        v-if="contest"
    >
        <contests-contest-page-template
            title="Tips"
            :content="contest.tips_content"
        ></contests-contest-page-template>
    </div>
</template>
<script>
import ContestsContestPageTemplate from "@/js/components/contests/ContestsContestPageTemplate";
import {ENV_URL} from "../../environment";
export default {
    components: {
        ContestsContestPageTemplate,
    },
    computed: {
        contest() {
            return this.$store.state.contest;
        },
    },
    mounted () {
        const uri = ENV_URL + this.$route.path;
        this.$store.dispatch('GET_CONTEST_PAGE', {uri});
    },
}
</script>